import colors from '@/theme/colors';
import { css } from '@emotion/css';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    margin-top: 16px;
    position: relative;
    cursor: pointer;
    padding-right: 28px;
  `,
  arrowRightIcon: css`
    position: absolute;
    top: 10px;
    right: 0px;
    cursor: pointer;
    color: ${colors.prussian};
    .MuiSvgIcon-root {
      font-size: 16px;
    }
  `,
};

export default styles;
